import {handleActions} from 'redux-actions'

import * as ActionTypes from './actionTypes'

const initialState = {
    inProgress: false
}

export default handleActions({
    [ActionTypes.CSV_EXPORT_IN_PROGRESS_SET]: (state, {payload: inProgress}) => ({
        ...state,
        inProgress,
    })
}, initialState);


// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/reducer.js